exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.seatStatusItem {\n    text-align: center;\n    padding: 2px 0;\n}\n.seatStatusItem img {\n    position: relative;\n    z-index: 1;\n    height: 25px;\n    width: auto;\n    margin-bottom: 4px;\n}\n.seatStatusItem h5 {\n    font-size: 10px;\n    line-height: 13px;\n    margin-bottom: 0;\n}\n", ""]);

// exports
